import { type SVGProps, useId } from 'react';
import { ZepIcon } from '@zep-us/zus-icons';

/**
 * 공유 창 클래스 줄의 학교 아이콘 (피그마 SchoolFill + gradient/mint-blue).
 *
 * ZUS `SchoolFillIcon` 은 단색이라 그라디언트를 못 받는다. 같은 화면에 여러 개
 * 그려도 `<defs>` id 가 겹치지 않게 `useId()` 로 인스턴스마다 발급한다
 * (WorksheetGradientIcon 과 같은 방식).
 */
export const SchoolGradientIcon = ZepIcon((props: SVGProps<SVGSVGElement>) => {
  const gradientId = useId();
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.1992 2.5C11.1992 2.22386 11.4231 2 11.6992 2H15.1992C15.7515 2 16.1992 2.44772 16.1992 3V5C16.1992 5.55228 15.7515 6 15.1992 6H12.5992V6.50701C12.6144 6.51842 12.6294 6.53032 12.6441 6.54271L17.6441 10.7532C17.8698 10.9432 18 11.2232 18 11.5181V12H21C21.5523 12 22 12.4477 22 13V20C22 20.5523 21.5523 21 21 21H17.0238L17 21.0003H7L6.97625 21H3C2.44772 21 2 20.5523 2 20V13C2 12.4477 2.44772 12 3 12H6V11.5181C6 11.2232 6.13023 10.9432 6.35586 10.7532L11.1992 6.67462V2.5ZM12 14.0003C12.8284 14.0003 13.5 13.3287 13.5 12.5003C13.5 11.6718 12.8284 11.0003 12 11.0003C11.1716 11.0003 10.5 11.6718 10.5 12.5003C10.5 13.3287 11.1716 14.0003 12 14.0003Z" fill={`url(#${gradientId})`} />
      <defs>
        <linearGradient id={gradientId} x1="2" y1="11.5001" x2="22" y2="11.5001" gradientUnits="userSpaceOnUse">
          <stop stopColor="#18D0B4" />
          <stop offset="1" stopColor="#6EBFFF" />
        </linearGradient>
      </defs>
    </svg>;
});